import React from 'react';

import { ReactComponent as AntennaIcon } from 'assets/images/icons/antenna.svg';

import styles from 'assets/scss/modules/Gateways/Gateways.module.scss';

export interface StatsValue {
  total: number;
  online: number;
  offline: number;
  neverSeen: number;
}

interface Props {
  value: StatsValue;
}

export const StatsCards: React.FC<Props> = ({ value }) => {
  return (
    <div className={styles.statsGrid}>
      <div className={`${styles.statCard} ${styles.statCardTotal}`}>
        <div className={styles.statTop}>
          <div className={styles.statValue}>{value.total}</div>
          <AntennaIcon className={styles.statIcon} />
        </div>
        <div className={styles.statLabel}>Total gateways</div>
      </div>

      <div className={`${styles.statCard} ${styles.statCardOnline}`}>
        <div className={styles.statTop}>
          <div className={styles.statValue}>{value.online}</div>
          <span className={`${styles.statDot} ${styles.statDotOnline}`} />
        </div>
        <div className={styles.statLabel}>Online</div>
      </div>

      <div className={`${styles.statCard} ${styles.statCardOffline}`}>
        <div className={styles.statTop}>
          <div className={styles.statValue}>{value.offline}</div>
          <span className={`${styles.statDot} ${styles.statDotOffline}`} />
        </div>
        <div className={styles.statLabel}>Offline</div>
      </div>

      <div className={`${styles.statCard} ${styles.statCardNeverSeen}`}>
        <div className={styles.statTop}>
          <div className={styles.statValue}>{value.neverSeen}</div>
          <span className={`${styles.statDot} ${styles.statDotNeverSeen}`} />
        </div>
        <div className={styles.statLabel}>Never seen</div>
      </div>
    </div>
  );
};
